import { CoralColors } from '@krakentech/coral';

export const createSegmentPath = (
  startAngle: number,
  endAngle: number,
  radius: number
): string => {
  const startRad = (startAngle - 90) * (Math.PI / 180);
  const endRad = (endAngle - 90) * (Math.PI / 180);

  const x1 = radius * Math.cos(startRad);
  const y1 = radius * Math.sin(startRad);
  const x2 = radius * Math.cos(endRad);
  const y2 = radius * Math.sin(endRad);

  const largeArcFlag = Math.abs(endAngle - startAngle) > 180 ? 1 : 0;

  return `M 0 0 L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
};

export const calculateSegmentAngles = (
  index: number, // This is the index of the segment, starting from 0
  totalSegments: number
) => {
  const segmentAngle = 360 / totalSegments;
  const startAngle = index * segmentAngle;
  const endAngle = startAngle + segmentAngle;
  return { startAngle, endAngle };
};

export const calculateTextPosition = (
  startAngle: number,
  endAngle: number,
  radius: number = 150
) => {
  const textAngle = (startAngle + endAngle) / 2;
  const textX = radius * Math.cos((textAngle - 90) * (Math.PI / 180));
  const textY = radius * Math.sin((textAngle - 90) * (Math.PI / 180));
  return { textX, textY, textAngle };
};

export const getWheelColours = (color: CoralColors): string[] => [
  color.primary?.main, // dark blue (stw)
  color.primary?.dark, // teal (stw)
  color.text?.dark, // dark grey (stw)
  color.primary?.light, // light blue-grey (stw)
];

export const createSegments = (
  color: CoralColors,
  visualPrizeAmounts: string[],
  totalSegments: number
) => {
  const wheelColours = getWheelColours(color);

  return Array.from({ length: totalSegments }, (_, index) => ({
    id: `segment-${index}`,
    colour: wheelColours[index % wheelColours.length],
    prize: visualPrizeAmounts[index % visualPrizeAmounts.length],
  }));
};
